import React, { useState } from 'react'
import styled from 'styled-components'
import { getIsOpen, getContent, getConfigPath } from 'modules/top_banner'
import { Link, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from 'store'
import { publishMeDoorV1 } from 'apis/doors'
import topBannerModules, { TopBannerContent } from 'modules/top_banner'
import ConfirmPublishModal from 'components/door/ConfirmPublishModal'
import { logger } from 'utils/logger'
import Cookies from 'universal-cookie'

const DoorCannotPublish = () => {
  const configPath =
    useSelector((state: RootState) => getConfigPath(state)) || ''
  return (
    <>
      <DoorCannotPublishContainer>
        <p style={{ display: 'flex', flexWrap: 'wrap' }}>
          <span>サロンは非公開です。</span>
          <span>
            公開するには
            <Link to={configPath} rel="nofollow">
              ここから
            </Link>
            必須情報を登録してください
          </span>
        </p>
        <BtnWrap>
          <span
            className="btn btn-disabled btn-size1"
            style={{
              height: '30px',
              width: '175px'
            }}
          >
            公開
          </span>
        </BtnWrap>
      </DoorCannotPublishContainer>
    </>
  )
}

const DoorPersonalInfoRequired = () => {
  const configPath =
    useSelector((state: RootState) => getConfigPath(state)) || ''
  return (
    <DoorCannotPublishContainer>
      <p>
        <Link to={configPath} rel="nofollow">
          サロン設定
        </Link>
        の必須項目を設定してください
      </p>
    </DoorCannotPublishContainer>
  )
}

const DoorOwnerPersonalInfoRequired = () => (
  <DoorCannotPublishContainer>
    <p>
      サロンは非公開です。公開するにはサロン作成者が本人確認情報を登録してください
    </p>
  </DoorCannotPublishContainer>
)

const baseStyle: React.CSSProperties = {
  fontWeight: 'bold'
}

/*
 * FIXME
 * 画面固有のロジックが本ファイル内に書かれてしまうため、バナー内の子要素はsetMessageの呼び出し元で指定できるようにしたい。
 * reduxのstateにコンポーネントを指定すれば良さそうだが、意図しないバグが起きそうなのでやめた。（未検証）
 */

type Props = {
  doorId: string
}
export default function TopBanner(props: Props) {
  const { doorId } = props
  const isOpen = useSelector((state: RootState) => getIsOpen(state))
  const content = useSelector((state: RootState) => getContent(state))

  const DoorCanPublish = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [openModal, setOpenModal] = useState(false)
    const [published, setPublished] = useState(false)
    const [sending, setSending] = useState(false)
    const handlePublish = async () => {
      setSending(true)
      try {
        await publishMeDoorV1(doorId)
        const cookies = new Cookies()
        cookies.remove('yoora8id', {
          secure: true,
          domain: '.yoor.jp'
        })
        setPublished(true)
      } catch (err) {
        logger.debug(err)
      } finally {
        setSending(false)
      }
    }
  
    const handleClose = () => {
      if (published) {
        dispatch(topBannerModules.actions.setClose())
        window.location.href = `/door/${window.location.pathname.split('/')[2]}?salon=open`
      }
      setOpenModal(false)
    }
  
    return (
      <>
        <AlertWrap>
          <p>公開準備が整いました！</p>
          <BtnWrap>
            <button
              className="btn btn-size1"
              style={{
                height: '30px',
                width: '175px',
                backgroundColor: '#FFFF',
                color: '#41A091'
              }}
              onClick={() => setOpenModal(true)}
            >
              公開
            </button>
          </BtnWrap>
          <ConfirmPublishModal
            doorId={doorId}
            open={openModal}
            handleClose={handleClose}
            handlePublish={handlePublish}
            published={published}
            disabled={sending}
          />
        </AlertWrap>
      </>
    )
  }
  const items: Array<{
    content: TopBannerContent
    component: React.FC
    style: React.CSSProperties
  }> = [
    {
      content: 'door_cannot_publish',
      component: DoorCannotPublish,
      style: {
        ...baseStyle,
      }
    },
    {
      content: 'door_personal_info_required',
      component: DoorPersonalInfoRequired,
      style: {
        ...baseStyle,
      }
    },
    {
      content: 'door_owner_personal_info_required',
      component: DoorOwnerPersonalInfoRequired,
      style: {
        ...baseStyle,
      }
    },
    {
      content: 'door_can_publish',
      component: DoorCanPublish,
      style: {
        ...baseStyle,
        backgroundColor: '#41A091',
        color: '#FFFF'
      }
    }
  ]
  const item = items.find((v) => v.content === content)

  return (
    <React.Fragment>
      {isOpen && item && (
        <div style={item.style}>{React.createElement(item.component)}</div>
      )}
    </React.Fragment>
  )
}

const AlertWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: #41a091;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  @media screen and (max-width: 640px) {
    padding: 8px 12px;
    font-size: 12px;
    flex-direction: column;
    text-align: center;
  }
`

const DoorCannotPublishContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: #fedba0;
  @media (max-width: 480px) {
    display: block;
    z-index: 10;
    position: relative;
    text-align: center;
  }
`
const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
  @media (min-width: 481px) {
    margin-left: 16px;
  }
  @media (max-width: 480px) {
    margin-top: 12px;
  }
`
